import { render, staticRenderFns } from "./DIASUpload.vue?vue&type=template&id=4cc2d08e&"
import script from "./DIASUpload.vue?vue&type=script&lang=js&"
export * from "./DIASUpload.vue?vue&type=script&lang=js&"
import style0 from "./DIASUpload.vue?vue&type=style&index=0&id=4cc2d08e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports